(ns frontend.view.settings2.kyc.model)

(def root-path [::state])

(def configuration-key :configuration)

(def configuration-full-path (conj root-path configuration-key))

(def reminder-config-full-path (vec (concat configuration-full-path [:reminder-config])))

(def saving-key :saving?)

(def saving-full-path (conj root-path saving-key))

(def automated-renewal-enabled-key :automated-renewal-enabled?)

(def automated-renewal-enabled-full-path (conj root-path automated-renewal-enabled-key))
